import { useLocalStorageState } from 'ahooks'
import { track } from 'lib/amplitude'
import { useCallback } from 'react'
import { useAuthContext } from 'components/auth/useAuthContext'
import { PermissionEnum } from 'api/userPermissions'

/*
 * Previously used keys:
 * - pulse
 */

const BANNER_KEY = 'pulse'

export const useTopBanner = () => {
  const { hasPermission } = useAuthContext()
  const [dismissedTopBanner, setDismissedTopBanner] = useLocalStorageState(
    `dismissed-top-banner-${BANNER_KEY}`,
    {
      defaultValue: false,
      listenStorageChange: true,
    }
  )

  const show =
    !dismissedTopBanner && hasPermission(PermissionEnum.PaymentAccess)
  const dismiss = useCallback(() => {
    setDismissedTopBanner(true)

    track('button_click, top_banner_dismiss', {
      banner: BANNER_KEY,
    })
  }, [setDismissedTopBanner])

  return {
    show,
    dismiss,
  }
}
